import { EntityDescriptor, EntityEditorPage, EntityEditorPageProps } from "@crispico/foundation-react";
import { TabRouterPane } from "@crispico/foundation-react/components/TabbedPage/TabbedPage";

export class ObuEntityDescriptor extends EntityDescriptor {

    constructor() {
        super({ name: "Obu", miniFields: ["serialNumber"] });
    }

    protected customize() {
        this.infoEditor.wrappedComponentClass = class extends EntityEditorPage<EntityEditorPageProps> {
            protected getExtraTabPanes(): (TabRouterPane | null)[] {
                return [
                    ...super.getExtraTabPanes(),
                    this.createOneToManyTabPane("ObuCommandHistory", "obu"),
                ];
            }
        }
    }
}
